import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, Signal, inject, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { getUVEState } from '@dotcms/uve';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { AccountFacade } from 'ish-core/facades/account.facade';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

import { DotCmsUveEditContentletWrapperComponent } from '../../components/dot-cms-uve-edit-contentlet-wrapper/dot-cms-uve-edit-contentlet-wrapper.component';
import { DotCmsUveSetAttributesDirective } from '../../directives/dot-cms-uve-set-attributes.directive';
import { DotCmsUveFacade } from '../../facades/dot-cms-uve.facade';

@Component({
  selector: 'custom-dot-cms-uve-footer',
  imports: [
    ServerHtmlDirective,
    DotCmsUveSetAttributesDirective,
    DotCmsUveEditContentletWrapperComponent,
    ModalDialogComponent,
  ],
  templateUrl: './dot-cms-uve-footer.component.html',
  styleUrl: './dot-cms-uve-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsUveFooterComponent implements AfterViewInit, OnDestroy {
  $pageState: Signal<any>;
  isInsideEditor = !!getUVEState();
  private dotCmsUveFacade = inject(DotCmsUveFacade);
  private accountFacade = inject(AccountFacade);
  conformDialog = viewChild<ModalDialogComponent<any>>('conformDialog');

  constructor() {
    this.$pageState = this.dotCmsUveFacade.pageState;
  }

  emailInput: HTMLInputElement;

  newsLetterForm = new FormGroup({
    newsletterEmail: new FormControl('', [Validators.required, Validators.email]),
  });

  private observer: MutationObserver;

  ngAfterViewInit() {
    if (!SSR) {
      this.observer = new MutationObserver(() => this.handelNewsletterSubmit());
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  handelNewsletterSubmit() {
    this.emailInput = document.getElementById('newsletter_email') as HTMLInputElement;
    const submitButton = document.getElementById('signup_button') as HTMLInputElement;

    if (this.emailInput && submitButton) {
      submitButton.addEventListener('click', event => {
        event.preventDefault();
        this.newsLetterForm.get('newsletterEmail')?.setValue(this.emailInput.value);

        if (this.newsLetterForm.valid) {
          this.conformDialog()?.show();
        }
      });

      this.observer.disconnect();
    }
  }

  confirmMail() {
    this.accountFacade.updateNewsletterSubscription(true, this.emailInput.value, true);
    this.newsLetterForm.reset();
    if (this.emailInput) {
      this.emailInput.value = '';
    }
  }

  ngOnDestroy() {
    if (!SSR && this.observer) {
      this.observer.disconnect();
    }
  }
}
